/**
 * Deployment kill switch for the SPA. Omit `VITE_APP_ENABLED` ⇒ app runs.
 * `false` / `0` / `no` / `off` ⇒ only the unavailable screen is shown (no Convex/Clerk).
 */
export function isAppAvailable(env: ImportMetaEnv): boolean {
  const raw = env.VITE_APP_ENABLED as string | undefined;
  if (raw === undefined || raw === '') return true;
  const s = raw.toLowerCase().trim();
  if (s === '') return true;
  return s !== 'false' && s !== '0' && s !== 'no' && s !== 'off';
}
